import { inject, injectable } from "inversify";
import { ICPLAuthUserGroupClient, UserGroupModel, UserModel } from "./api/cplauthapi/CPLAuthAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IUserGroupsService {
  getAllUserGroups(): Promise<UserGroupModel[]>;
  getUserGroup(userGroupID: number | undefined): Promise<UserGroupModel>;
  createUserGroup(groupName: string | undefined): Promise<void>;
  updateUserGroup(userGroup: UserGroupModel): Promise<void>;
  deleteUserGroup(userGroupID: number | undefined): Promise<void>;
  getUserGroupMembers(userGroupID: number | undefined): Promise<UserModel[]>;
  addUserToGroup(userID: string | undefined, userGroupID: number | undefined): Promise<void>;
  deleteUserFromGroup(userID: string | undefined, userGroupID: number | undefined): Promise<void>;
}

@injectable()
export class UserGroupsService implements IUserGroupsService {
  @inject(SERVICE_TYPES.CPLAuthUserGroupsClient) cplAuthUserGroupsClient!: ICPLAuthUserGroupClient;

  getAllUserGroups(): Promise<UserGroupModel[]> {
    return this.cplAuthUserGroupsClient.getAllUserGroups();
  }

  getUserGroup(userGroupID: number): Promise<UserGroupModel> {
    return this.cplAuthUserGroupsClient.getUserGroup(userGroupID);
  }

  updateUserGroup(userGroup: UserGroupModel): Promise<void> {
    return this.cplAuthUserGroupsClient.updateUserGroup(userGroup);
  }

  createUserGroup(groupName: string): Promise<void> {
    return this.cplAuthUserGroupsClient.createUserGroup(groupName);
  }

  deleteUserGroup(userGroupID: number): Promise<void> {
    return this.cplAuthUserGroupsClient.deleteUserGroup(userGroupID);
  }

  getUserGroupMembers(userGroupID: number): Promise<UserModel[]> {
    return this.cplAuthUserGroupsClient.getUserGroupMembers(userGroupID);
  }

  addUserToGroup(userID: string, userGroupID: number): Promise<void> {
    return this.cplAuthUserGroupsClient.addUserToGroup(userID, userGroupID);
  }

  deleteUserFromGroup(userID: string, userGroupID: number): Promise<void> {
    return this.cplAuthUserGroupsClient.deleteUserFromGroup(userID, userGroupID);
  }
}
